module.exports = __webpack_public_path__ + "media/images/regions-618fc9e7d31f8dfb8b15ae3e0733bf52.svg";